/***ENAD */
import begginerlevel from "../../assets/icons/doodles-level/begginer-level.svg";
import divisionlevel from "../../assets/icons/doodles-level/division-level.svg";
import onedigitlevel from "../../assets/icons/doodles-level/one-digit-level.svg";
import subtractlevel from "../../assets/icons/doodles-level/subtract-level.svg";
import twodigitslevel from "../../assets/icons/doodles-level/two-digits-level.svg";
import comprehensionlevel from "../../assets/icons/doodles-level/comprehension-level.svg";
import { clearMarkdown } from "../../services/chat.service";
import { levelsEnglish } from "../custom_superpowers/british_council/LevelsEnglish";
export const iconslevels = {
    begginerlevel: { icon: begginerlevel, color: "[#9568A7]", alt: "Principiante" },
    divisionlevel: { icon: divisionlevel, color: "Yellow-500", alt: "División" },
    onedigitlevel: { icon: onedigitlevel, color: "Yellow-550", alt: "1 dígito" },
    subtractlevel: { icon: subtractlevel, color: "shaiaGreen", alt: "Resta" },
    twodigitslevel: { icon: twodigitslevel, color: "Red-500", alt: "2 dígitos" },
    comprehensionlevel: { icon: comprehensionlevel, color: "shaiaGreen", alt: "Comprensión" }
}

export const prompt_objetivos = (data) => {
    let { user, data: { area, groupingType, levels, objectives, name, considerations } } = data;
    levels = Array.isArray(levels) ? levels : [levels];
    area = Array.isArray(area) ? area : [area];
    groupingType = Array.isArray(groupingType) ? groupingType : [groupingType];
    considerations = Array.isArray(considerations) ? considerations : [considerations];
    objectives = Array.isArray(objectives) ? objectives : [objectives];

    return `
        Nombre de docente: ${user?.first_name || ""}  

        Contexto del grupo
        * Nombre del grupo: ${name}
        * Área de enseñanza:   ${area?.[0]?.value || ""}
        * Tipo de agrupación de los estudiantes: ${groupingType?.[0]?.value || ""}
        * Nivel(es) de los estudiantes: ${levels?.map(i => i?.value)?.join(",") || ""}
        * Número de estudiantes en cada nivel:${levels?.map(i => `${i?.value}:${i?.studentsNumber ?? 0}`)?.join(",") || ""}
        * Contexto adicional: ${considerations?.map(i => i?.value)?.join(",") || ""}

        * Objetivo(s) de aprendizaje para validar: ${objectives?.map(i => i)?.join(",") || ""}
    `
}


export const prompt_objetivos_modificar = (crroption) => (data) => {
    const { ideas, option, current } = crroption;
    let { user, data: { area, groupingType, levels, name, considerations } } = data;
    levels = Array.isArray(levels) ? levels : [levels];
    area = Array.isArray(area) ? area : [area];
    considerations = Array.isArray(considerations) ? considerations : [considerations];
    groupingType = Array.isArray(groupingType) ? groupingType : [groupingType];

    return `
        Nombre de docente: ${user?.first_name || ""} 

        Contexto del grupo
        * Nombre del grupo: ${name}
        * Área de enseñanza:   ${area?.[0]?.value || ""}
        * Tipo de agrupación de los estudiantes: ${groupingType?.[0]?.value || ""}
        * Nivel(es) de los estudiantes: ${levels?.map(i => i?.value)?.join(",") || ""}
        * Número de estudiantes en cada nivel:${levels?.map(i => `${i?.value}:${i?.studentsNumber ?? 0}`)?.join(",") || ""}
        * Contexto adicional: ${considerations?.map(i => i?.value)?.join(",") || ""}


        * Objetivo(s) de aprendizaje previamente definidos: ${current}

        * Objetivo(s) específicos a modificar de los previamente definidos:  ${option}

        * Esta es la idea que tengo en mente para modificar los objetivos de aprendizaje:${ideas} 

    `
}

export const optionsENAD = [
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Principiante",
        "icon": "begginerlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Letra",
        "icon": "onedigitlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Palabra",
        "icon": "twodigitslevel"
    },
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Párrafo",
        "icon": "subtractlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Cuento",
        "icon": "divisionlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Principiante + letra",
        "icon": "begginerlevel,onedigitlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Palabra + párrafo",
        "icon": "twodigitslevel,subtractlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Comprensión",
        "icon": "comprehensionlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Principiante",
        "icon": "begginerlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Letra",
        "icon": "onedigitlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Palabra",
        "icon": "twodigitslevel"
    },
    {
        "area": "Lectura",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Párrafo",
        "icon": "subtractlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Cuento",
        "icon": "divisionlevel"
    },
    {
        "area": "Lectura",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Comprensión",
        "icon": "comprehensionlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Principiante",
        "icon": "begginerlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "1 dígito",
        "icon": "onedigitlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "2 dígitos",
        "icon": "twodigitslevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Resta",
        "icon": "subtractlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "División",
        "icon": "divisionlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Principiante + 1 dígito",
        "icon": "begginerlevel,onedigitlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Resta + división",
        "icon": "subtractlevel,divisionlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Homogénea",
        "labelkey": "student_grouping_level",
        "intructionskey": "student_grouping_level_instruction",
        "questionkey": "how_many_students_in_this_group",
        "limit": [1, 1],
        "nivel": "Problemas",
        "icon": "twodigitslevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Principiante",
        "icon": "begginerlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "1 dígito",
        "icon": "onedigitlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "2 dígitos",
        "icon": "twodigitslevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Resta",
        "icon": "subtractlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "División",
        "icon": "divisionlevel"
    },
    {
        "area": "Matemáticas",
        "tipo": "Heterogénea",
        "labelkey": "student_grouping_levels",
        "intructionskey": "student_grouping_levels_instruction",
        "questionkey": "how_many_students_in_this_group_per_level",
        "limit": [2, 6],
        "nivel": "Problemas",
        "icon": "twodigitslevel"
    }
];

export const createbodyenad = ({ data, user }) => {
    //Se formatean y limian los objetivos, consideraciones y niveles
    // La limpieza de markdown se hace en elos objetivos previo al envio 
    const objective_list = data?.objetivesOptions?.map(i => i?.option?.[0] ? ({ label: clearMarkdown(i?.option?.[0]) }) : null).filter(Boolean);
    const body = {
        "user_email": user?.email,
        "class_name": data?.name,
        "objectivetovalidate": data?.objectives,
        "objective_list": JSON.stringify(objective_list),
        "type": "group",
        "institution_id": user?.institutionalUser?.subscription?.institution?.id,
        "student_level": JSON.stringify([{
            "levels": data?.levels?.map(i => ({ label: i.value, studentsNumberGroup: i.studentsNumber ?? 0 })),
            "knowledge_area": data?.area?.value,
            "group_type": data?.groupingType?.value
        }]),
        "consideration_list": JSON.stringify(data?.considerations?.map(i => i?.value ? ({ label: i?.value }) : null)?.filter(Boolean)),
    }
    return body;
}

export const dataToFormDataEnad = (data, { config }) => {
    let student_level = null
    try {
        student_level = JSON.parse(data?.student_level)?.[0];
    } catch (error) { }
    let groupingType = config?.find(i => i?.tipo === student_level?.group_type);
    groupingType = groupingType ? { ...groupingType, label: groupingType?.tipo, value: groupingType?.tipo } : null;
    let levels = student_level?.levels?.map(level => {
        let _level = config?.find(i => i?.area === student_level?.knowledge_area && i?.tipo === student_level?.group_type && i?.nivel === level?.label);
        return { ..._level, label: _level?.nivel, value: _level?.nivel, studentsNumber: level?.studentsNumberGroup }
    });
    let objetivesOptions = data?.objectives?.map(i => ({ ...i, option: [i?.description] }));
    let dataformated = {
        "name": data?.class_name,
        "area": {
            "value": student_level?.knowledge_area,
            "label": student_level?.knowledge_area
        },
        "groupingType": groupingType,
        "considerations": data?.considerations?.map(i => ({ ...i, "label": i?.description, "value": i?.description })),
        "levels": levels,
        "objetivesOptions": objetivesOptions,
        "objectives": "",
        "ideas": ""
    }
    return dataformated;
}

/******************ENAD */

/************BC */
export const OptionsBC = {
    objectivesTypes: [
        { value: "Objetivo personalizado", label: "Objetivo personalizado", code: "OP" },
        { value: "Estándares nacionales (Derechos Básicos de aprendizaje - Colombia)", label: "Estándares nacionales (Derechos Básicos de aprendizaje - Colombia)", code: "DBA" },
        { value: "Malla curricular sugerida por el British Council", label: "Malla curricular sugerida por el British Council", code: "MC" }
    ],
    optionsMC: [
        { value: "Malla Transición", label: "Malla Transición" , conditional: ["Transición", "Primero", "Segundo"]},
        { value: "Malla Primero", label: "Malla Primero", conditional: ["Primero", "Segundo", "Tercero"] },
        { value: "Malla Segundo", label: "Malla Segundo", conditional: ["Segundo", "Tercero", "Cuarto"] },
        { value: "Malla Tercero", label: "Malla Tercero", conditional: ["Tercero", "Cuarto", "Quinto"] },
        { value: "Malla Cuarto", label: "Malla Cuarto", conditional: ["Cuarto", "Quinto", "Sexto"] },
        { value: "Malla Quinto", label: "Malla Quinto", conditional: ["Quinto", "Sexto", "Séptimo"] },
        { value: "Malla Sexto", label: "Malla Sexto", conditional: ["Sexto", "Séptimo", "Octavo"] },
        { value: "Malla Séptimo", label: "Malla Séptimo", conditional: ["Séptimo", "Octavo", "Noveno"] },
        { value: "Malla Octavo", label: "Malla Octavo", conditional: ["Octavo", "Noveno", "Décimo"] },
        { value: "Malla Noveno", label: "Malla Noveno", conditional: ["Noveno", "Décimo", "Undécimo"] },
        { value: "Malla Décimo", label: "Malla Décimo", conditional: ["Décimo", "Undécimo"] },
        { value: "Malla Undécimo", label: "Malla Undécimo", conditional: ["Undécimo"] }
    ],
    optionsLevels: levelsEnglish
}

export const createbodybc = ({ data, user }) => {
    let objective_list = [],dba_ids = [],maya_curricular = [];
    data?.objetivesOptions?.forEach?.(element => {
        if(element?.type?.code === "DBA") dba_ids.push(element?.id);
        else if(element?.type?.code === "MC") maya_curricular.push({label:element?.option?.[0],created_at:element?.created_at??new Date().toISOString()});
        else objective_list.push({ label: clearMarkdown(element?.option?.[0]) });
    });
    const grade = Array.isArray(data?.grade) ? data?.grade : [data?.grade];
    const asignature = Array.isArray(data?.asignature) ? data?.asignature : [data?.asignature];
    const body = {
        class_name: data?.name,
        number_students: data?.studentsNumber,
        institution_id: data?.institution?.value,
        grade_level_ids: JSON.stringify(grade?.map?.(i => i?.value) ?? []),
        subject_area_ids: JSON.stringify(asignature?.map?.(i => i?.value) ?? []),
        user_email: user?.email,
        calendar: JSON.stringify(data?.calendario),
        dba_ids:JSON.stringify(dba_ids),
        objective_list: JSON.stringify(objective_list),
        consideration_list: JSON.stringify(data?.considerations?.map(i => i?.value ? ({ label: i?.value }) : null)?.filter(Boolean)),
        resource_list: JSON.stringify(data?.resources?.map(i => ({ label: i?.value })) ?? []),
        student_level: JSON.stringify([{
            levels: data?.levels?.map?.(i => i.value),
            maya_curricular
        }]),
        type: "coursebc"
    }
    return body;
}

export const dataToFormDataBC = (data, { config }) => {
    let student_level = null
    try {
        student_level = JSON.parse(data?.student_level)?.[0];
    } catch (error) { }
    const {updated_at} = data;
    let objetivesOptions = [];
    data?.dbas?.forEach?.(element => {
        objetivesOptions.push({ ...element,created_at:updated_at ,option:[element?.standard], type: OptionsBC?.objectivesTypes?.find?.(i => i?.code === "DBA") });
    });

    data?.objectives?.forEach?.(element => {
        objetivesOptions.push({ ...element, option: [element?.description], type: OptionsBC?.objectivesTypes?.find?.(i => i?.code === "OP") });
    });

    student_level?.maya_curricular?.forEach?.(element => {
        objetivesOptions.push({ ...element, option: [element?.label], type: OptionsBC?.objectivesTypes?.find?.(i => i?.code === "MC") });
    });

    objetivesOptions = objetivesOptions.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at));
    
    let dataformated = {
        "name": data?.class_name,
        studentsNumber:data?.number_students,
        institution: {value:data?.institution?.id,label:data?.institution?.name},
        grade: {label:data?.gradeLevels?.[0]?.name, value:data?.gradeLevels?.[0]?.id},
        asignature: {label:data?.subjectAreas?.[0]?.name, value:data?.subjectAreas?.[0]?.id},
        calendario:data?.classProfileCalendars,
        considerations:data?.considerations?.map(i => ({ ...i, "label": i?.description, "value": i?.description })),
        resources: data?.resources?.map(i => ({ ...i, "label": i?.description, "value": i?.description })),
        levels: student_level?.levels?.map(level => {
            const item = OptionsBC.optionsLevels.find(i => i?.value.trim() === level.trim());
            return item;
        }).filter(Boolean),
        objetivesOptions
    }
    return dataformated;
}

/************BC */


export const configuration = {
    FAAQ: {
        menu: [
            {
                title: "Curso",
                description: "choose_this_option_other_courses_enad",
                customColorTitle: "text-LightBlue-500",
                type: "course"
            },
            {
                title: "group",
                description: "choose_this_option_ENAd",
                customColorTitle: "text-Yellow-550",
                type: "group"
            }
        ],
        options: optionsENAD
    },
    BC: {
        options: OptionsBC
    }
}
